<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :hide-actions="true"
      :items="items"
      :rows-per-page-items="[10]"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>{{ shipment.forecastDeliveryDate}}</td>
        <td>{{ props.item.departureType=='PORT'?props.item.departurePortName:props.item.departureWarehouseName }}</td>
        <td>{{ props.item.destinationWarehouseName }}</td>
        <td>{{props.item.deliverySupplierName}}</td>
        <td>{{props.item.deliveryModelName}}</td>
        <td>{{ containerNo() }}</td>
        <td>{{ containerType() }}</td>
        <td>{{ props.item.freightCost|currency }}</td>
        <td>{{ props.item.devanCharge|currency }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: ['items', 'shipment'],
  data() {
    return {
      selected: [],
      headers: [
        { text: '配送日', value: 'deliveryDate', sortable: false },
        { text: '発地', value: 'place', sortable: false },
        { text: '着地', value: 'landing', sortable: false },
        { text: '配送業者', value: 'deliverySupplierName', sortable: false },
        { text: '搬送サービス', value: 'deliveryModelName', sortable: false },
        { text: 'コンテナNO', value: 'containerNo', sortable: false },
        { text: 'タイプ', value: 'type', sortable: false },
        { text: '運送費', value: 'freightCost', sortable: false },
        { text: 'デバン料', value: 'devanCharge', sortable: false }
      ]
    }
  },
  methods: {
    containerNo() {
      return this.shipment.packages[0].containerNo
    },
    containerType() {
      return this.shipment.packages[0].containerTypeCode
    }
  }
}
</script>
